import React from "react"

export default [
	{
		title: "Аналитика и финансы",
		description:
			"Настраиваемые дашборды, отчёты, аналитика, расчёты, уведомления и&nbsp;приложение для руководителя.",
	},
	{
		title: "Маркетинг и CRM",
		description:
			"Инструменты работы с&nbsp;гостями: акции, бонусы, рассылки и&nbsp;уведомления.",
	},
	{
		title: "Управление складом",
		description:
			"Товарооборот под контролем — от закупок и прихода, до списания, актов разбора и переработки.",
	},
]
